import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { Icd10FacetView } from '@lib/guarantees/data-access';
import { TranslatePipe } from '@ngx-translate/core';

import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

import { CHECK_ROW_CLASS, CheckBoxComponent } from '../common/check-box.component';

/**
 * Picks ICD-10 branches at whatever depth suits: the checkbox adds a branch, the arrow opens it.
 *
 * Browsing must never filter, which is what lets picks accumulate across chapters. Lives inside the
 * filter dropdown: a control that reshapes as it is browsed cannot hold a fixed place in the header.
 */
@Component({
  selector: 'guarantees-icd10-filter',
  standalone: true,
  imports: [MatIcon, MatTooltip, TranslatePipe, CheckBoxComponent],
  templateUrl: './icd10-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Icd10FilterComponent {
  /** The same hit area and hover every checkable row in the filter panel uses. */
  protected readonly checkRow = CHECK_ROW_CLASS;

  facets = input.required<Icd10FacetView>();

  /** Adding and removing a pick are the same intent; the slice knows which way it goes. */
  prefixToggled = output<string>();
  /** Null steps the picker back to the chapter list. */
  cursorChanged = output<string | null>();
  cleared = output<void>();
}
